import { Input } from "./Input";
import type { InputProps } from "./Input";
import { FieldError } from "./FieldError";
import { twMerge } from "tailwind-merge";

interface InputFieldProps extends InputProps {
  label?: string;
  errorMessage?: string;
}

export function InputField({
  label,
  errorMessage,
  className,
  ...props
}: InputFieldProps) {
  const hasError = Boolean(errorMessage);

  return (
    <div className={twMerge("flex flex-col gap-2", className)}>
      {label && (
        <label
          htmlFor={props.name}
          className="text-status-neutral-content text-[13px] font-semibold"
        >
          {label}
        </label>
      )}

      <Input id={props.name} error={hasError} {...props} />

      {hasError && <FieldError message={errorMessage!} />}
    </div>
  );
}
